import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const startBatchAeoOnboarding = unaryRpc({
  name: "startBatchAeoOnboarding",
  input: z.object({
    teamIds: z.array(z.string()).optional(),
    numberOfPrompts: z.number().optional(),
  }),
  output: z.object({
    workflowId: z.string(),
    status: z.literal("started"),
    teamsQueued: z.number(),
    teamsSkippedCompleted: z.number(),
    totalAeoTeams: z.number().optional(),
  }),
});
